import { createSelector } from 'reselect';
import { getFromState } from 'helpers';

const getYouthAthlete = (state) => getFromState(() => state, 'youthAthlete');

export const getInitialYouthAthleteValues = createSelector(
  getYouthAthlete,
  (youthAthlete) => youthAthlete,
);
